import React from "react";
import { buttonBase } from "./PaymentButtons";
import { links } from "../data/content";
export function WhatsAppInvite() {
  return <section id="whatsapp" className="mx-auto max-w-xl px-6 pb-16" data-id="element-118" data-mp="1pgx9i034sml">
      <div className="mt-4 rounded-xl border border-wa/40 bg-wa/10 p-5 text-center" data-id="element-119" data-mp="3j79t8kps904h">
        <h2 className="mb-2 text-lg font-bold" data-id="element-120" data-mp="3o51jlaas4e6k">¿Todavía no querés comprar?</h2>
        <p className="mb-4 text-sm leading-relaxed text-soft" data-id="element-121" data-mp="3a5ti2ar58tz7">
          Si tenés dudas o querés conocer más antes de entrar, sumate al grupo gratuito de WhatsApp.
        </p>
        <a href={links.whatsapp} target="_blank" rel="noopener noreferrer" className={`${buttonBase} bg-wa text-black hover:bg-wa-dark`} data-id="element-122" data-mp="3e5ap38m7xz6h">
          Sumarme gratis al grupo de WhatsApp
        </a>
        <p className="mt-3 text-xs text-soft" data-id="element-123" data-mp="yfra2z1xv66y">Entrar al grupo es gratis y no requiere comprar la membresía.</p>
      </div>
    </section>;
}